<template>
    <div class="suggest-result">
        <template v-if="suggestData">
            <ul class="suggest-result__list" v-if="items.length > 0">
                <li
                        v-for="item in items" :key="item.DETAIL_PAGE_URL"
                        class="suggest-result__item"
                >
                    <a class="suggest-result__link" :href="item.DETAIL_PAGE_URL">
                        <span class="suggest-result__name">{{ item.NAME }}</span> {{ item.VALUE }}
                    </a>
                    <p v-if="item.PRICE" class="suggest-result__price" v-html="setPrice(item.PRICE)"></p>
                </li>
            </ul>

            <div v-else>Ничего не нашли</div>

            <div class="suggest-result__search-link" v-if="searchPage">
                <a :href="searchPage">Все результаты</a>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'suggest-result-catalog-coffee',

    props: {
        suggestData: {
            type: Object,
            default: () => ({
                ITEMS: [],
            }),
        },
    },

    methods: {
        setPrice(price) {
            return `от ${price}`;
        },
    },

    computed: {
        items() {
            if (!this.suggestData) return [];

            return Array.isArray(this.suggestData.ITEMS) ? this.suggestData.ITEMS : Object.values(this.suggestData.ITEMS);
        },

        searchPage() {
            return this.suggestData?.LIST_PAGE_URL;
        },
    },
};
</script>
